@if (loaderState) {
  <div class="spinner-container">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>
}
<p-toast />
<router-outlet></router-outlet>
